import DOMPurify from 'dompurify';

/**
 * For the editor: converts [text] placeholder patterns to <mark>text</mark>
 * (red highlight, brackets hidden). Call this when loading text into the editor.
 */
export function sanitizeForEditor(html: string): string {
    const processed = html
        .replace(/<\/?mark[^>]*>/g, '')              // strip any existing marks first
        .replace(/\[([^\]]*)\]/g, '<mark>$1</mark>'); // re-wrap without brackets
    return DOMPurify.sanitize(processed);
}

/**
 * Before saving: strips <mark> tags so placeholder text becomes plain text in
 * the DB. Brackets are not re-added — once saved, the text is no longer a placeholder.
 */
export function restorePlaceholderBrackets(html: string): string {
    return html.replace(/<mark[^>]*>([\s\S]*?)<\/mark>/g, '$1');
}

/**
 * For display/preview: wraps [text] patterns in <mark> without brackets.
 */
export function sanitizeStandardSection(html: string): string {
    const processed = html
        .replace(/\[([^\]]*)\]/g, '<mark>$1</mark>');
    return DOMPurify.sanitize(processed);
}
